import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditUsers from './edit-users/EditUsers';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { getCustomerInfo } from '../../redux/customers/customersActions';
import { resetCustomerInfo } from '../../redux/customers/customersReducer';
import CustomerInfo from './customer-info/CustomerInfo';
import CompanyProjects from './company-projects/CompanyProjects';
import useCustomerTabs from './useCustomerTabs';
import CommonTabs from '../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import CompanyAiFeatures from './company-ai-features/CompanyAiFeatures';

const Customer = () => {
  const { t } = useTranslation('customers');
  const { id } = useParams();
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState(0);

  const TABS = useCustomerTabs();

  const handleChangeTabs = useCallback((_, newTab) => {
    setSelectedTab(newTab);
  }, []);

  useEffect(() => {
    dispatch(getCustomerInfo({ id }));

    return () => {
      dispatch(resetCustomerInfo({ id }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <CustomerInfo />

      <CommonTabs tabs={TABS} value={selectedTab} onChange={handleChangeTabs} isFullWidth />

      <CommonTabPanel value={selectedTab} index={0}>
        <EditUsers />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={1}>
        <CompanyProjects />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={2}>
        <CompanyAiFeatures />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={3}>
        {t('restAPI')}
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={4}>
        {t('purchases')}
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={5}>
        {t('logs')}
      </CommonTabPanel>
    </>
  );
};

export default Customer;
